import { translateDeliveryLocationGroups, translateWeeklyDeliverySchedule, } from '.';
import { DeliveryLocationGroupFormModel, WeeklyDeliveryScheduleFormModel, } from '.';
var factoryUpdateFormFromSimulation = function (form, menuSetting, simulation) {
    setDeliveryLocationGroups(menuSetting, simulation);
    setTarget(menuSetting, simulation);
    setAdvancedSetting(form.campaign, simulation);
    form.campaign.isFromSimulation = true;
    return form;
};
export default factoryUpdateFormFromSimulation;
// 配信地点グループ
var setDeliveryLocationGroups = function (menuSetting, simulation) {
    var deliveryLocationGroups = translateDeliveryLocationGroups(simulation.menuSetting);
    menuSetting.deliveryLocationGroups = deliveryLocationGroups.map(DeliveryLocationGroupFormModel.assign);
    menuSetting.simulationLocationGroups = deliveryLocationGroups
        .filter(function (g) { return g.isSimulation; })
        .sort(function (a, b) { return b.isUsable - a.isUsable; });
};
// 配信対象設定更新
var setTarget = function (geoMenuSetting, simulation) {
    var menuSetting = simulation.menuSetting;
    geoMenuSetting.setTargetCode(menuSetting.targetCode);
    geoMenuSetting.enableRadiusAutomation = true;
    geoMenuSetting.minutesAgo = menuSetting.minutesAgo;
    geoMenuSetting.visitCount = menuSetting.visitCount;
    geoMenuSetting.radius = menuSetting.radius;
};
// 高度な設定更新
var setAdvancedSetting = function (campaign, item) {
    var _a = item.simulationPlan, advancedSetting = _a.advancedSetting, useAdvancedSetting = _a.useAdvancedSetting;
    campaign.useAdvancedSetting = useAdvancedSetting;
    campaign.advancedSetting.deliveryDevices = advancedSetting.deliveryDevices;
    campaign.advancedSetting.deliveryInventories =
        advancedSetting.deliveryInventories;
    campaign.advancedSetting.onlyJapaneseDevice =
        advancedSetting.onlyJapaneseDevice;
    campaign.advancedSetting.weeklyDeliverySchedule = translateWeeklyDeliverySchedule(advancedSetting.deliveryTimeSchedules).map(WeeklyDeliveryScheduleFormModel.assign);
    campaign.advancedSetting.demographicSetting.sex = advancedSetting.sex;
    campaign.advancedSetting.demographicSetting.marriage =
        advancedSetting.marriage;
    campaign.advancedSetting.demographicSetting.age = advancedSetting.age;
};
